export enum WREX_LINK_PREVIEW {
    /**
     * @value Edit resource preview
     * @description Title for describing the resource preview edition action.
     *
     * Here a "resource" can be a website URL, an article, etc. something that can be opened and read by a user. A link to the "resource" can be sent via email for instance.
     */
    EDIT_RESOURCE_PREVIEW = 'WREX_LINK_PREVIEW.EDIT_RESOURCE_PREVIEW',
    /**
     * @value Insert resource
     * @description Section label in an editor toolbar, to list "resources" options that can be inserted in the editor.
     * Here a "resource" can be a website URL, an article, etc. something that can be opened and read by a user. A link to the "resource" can be sent via email for instance.
     */
    INSERT_RESOURCE = 'WREX_LINK_PREVIEW.INSERT_RESOURCE',
    /**
     * @value {"one":"Resource","other":"Resources"}
     */
    RESOURCE = 'JOURNEYS_CORE.RESOURCE',
    /**
     * @value Resource not handled
     * @description Message to display to user to indicate that the current resource is not handled
     */
    RESOURCE_NOT_HANDLED = 'RESOURCES.RESOURCE_NOT_HANDLED',
    /**
     * @value Link-preview toolbar
     * @description Label for link-preview toolbar
     */
    TOOLBAR = 'WREX_LINK_PREVIEW.TOOLBAR',
}
